import SidebarAndPanesWithRouting from '@/components/layouts/SidebarAndPanesWithRouting.vue';
import Summary from './children/Summary.vue';

const rootRoute = {
  path: 'campaign',
  name: 'Campaign',
  component: SidebarAndPanesWithRouting,
  meta: {
    label: 'Campaigns',
    auth: true,
  },
  props: {
    baseResource: '/metrics/campaign',
    singleRouterView: true,
  },
};

const commonChildMeta = {
  auth: true,
  resource: rootRoute.path,
  parentName: rootRoute.name,
};

const childRoutes = [
  {
    path: 'summary',
    name: 'Metrics.Campaign.Summary',
    component: Summary,
    meta: {
      label: 'Summary',
      ...commonChildMeta,
    },
  },
];
rootRoute.props.children = childRoutes;
export default {
  ...rootRoute,
  children: childRoutes,
};
